import Router from 'components/Router'
import { Container, ThemeProvider } from '@mui/material'
import theme from './theme'

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Container>
        <Router />
      </Container>
    </ThemeProvider>
  );
}

export default App
